
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCursorDrawIcon as ObiCursorDrawIconElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cursor-draw-icon.js';
 
 
 

 
 export const ObiCursorDrawIcon = createComponent({
   react: React,
   tagName: 'obi-cursor-draw-icon',
   elementClass: ObiCursorDrawIconElement,
   events: {
     
   }
  });
 
 